import { Button } from '@shared/ui/button/Button';
import { Modal } from '@shared/ui/modal/Modal';
import type { Receipt } from '../types';

export interface ConfirmDeleteDialogProps {
  receipt: Receipt | null;
  /** true pendant la suppression (appel API en cours). */
  deleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Boîte de confirmation de suppression d'un ticket. */
export function ConfirmDeleteDialog({
  receipt,
  deleting,
  onConfirm,
  onCancel,
}: ConfirmDeleteDialogProps) {
  if (!receipt) return null;

  return (
    <Modal
      open={receipt !== null}
      onClose={onCancel}
      title="Supprimer ce ticket ?"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={deleting}>
            Annuler
          </Button>
          <Button
            onClick={onConfirm}
            disabled={deleting}
            className="bg-red-600 hover:bg-red-700 focus-visible:outline-red-600"
          >
            {deleting ? 'Suppression…' : 'Supprimer'}
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-600">
        Le ticket <span className="font-medium text-slate-900">{receipt.merchant}</span> (
        {receipt.fileName}) sera définitivement supprimé. Cette action est irréversible.
      </p>
    </Modal>
  );
}
